export const REQUEST_DELAY = 1000;
export const OPTIONS = { wait: REQUEST_DELAY };
export const TAG_ALREADY_EXISTS_REGEXP = /^Tag (.*?) already exists for (.*?)$/;
export const TAG_VALUE_TOO_LONG_REGEXP = /value too long/;
export const AUTOCOMPLETE_MAX_VISIBLE_OPTIONS = 3;
export const AUTOCOMPLETE_DROPDOWN_MENU_MARGIN = 30;
export const AUTOCOMPLETE_TAGS_PAGE_SIZE = 50;
